import React, { useEffect, useRef, useState } from "react";
import Layout from "Layout";
import "./styles.scss";
import AccountDetail from "components/Account/trader_account_info";
import AccountListView from "components/Account/account_list_view";
import AccountSortView from "components/Account/account_sort_view";
import { Button, message, Modal, Pagination, Select, Space, Checkbox, Radio, Tooltip } from 'antd';
import CredentialsModal, {
  NewAccountCredentials,
  EditAccount,
} from "components/Account/credentialsModal";
import { mixGetV1, mixPostV1, mixPostV2 } from "services/mixin";
import { API_URL, BOT_ZIGZAG_URL } from "../../../env";
import { Helmet } from "react-helmet-async";
import { useAccount } from "components/Provider/account";
import TelegramButton from "components/Account/TelegramButton";
import Dragger from "antd/es/upload/Dragger";
import { CloudUploadOutlined } from '@ant-design/icons';
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getUnreadCount } from "pages/Notifications/function";
import { Search, Filter, LayoutGrid, List, ArrowUpDown, RotateCw, Download } from "lucide-react";
import FillterOptions from "./fillterOption";
import { useAppNotification } from "hooks/useNotification";
const CheckboxGroup = Checkbox.Group;
const { Option } = Select;
interface UserData {
  accountId: string;
  masterPassword: string;
  readOnlyPassword: string;
  platform: string;
  broker: string;
}
export let userData: UserData[] = [];

const Dashboard: React.FC = () => {
  const tradeAccountNumber = 6
  const [isShowModalCredentials, setIsShowModalCredentials] = useState(false);
  const [newAccountModal, setNewAccountModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [countUpdate, setCountUpdate] = useState<number>(0)
  const [countSecond, setCountSecond] = useState<number>(11)
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [userId, setUserId] = useState<string>('')
  const [notificationUnreadLength, setNotificationUnreadLength] = useState(0)
  const [viewMode, setViewMode] = useState<'grid' | 'list' | 'sort'>('grid')
  const [editingAccount, setEditingAccount] = useState<{
    accountId: number;
    account_number: string;
    nickName: string;
    balanceSize: number;
    platform: string;
    broker: string;
    accountType: string;
  } | null>(null)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const { t } = useTranslation();
  const notification = useAppNotification();
  const { notVisibleList, setNotVisibleList } = useAccount();
  const [status, setStatus] = useState<'loading' | 'error' | 'success'>('loading');
  const [userLevelAccounts, setUserLevelAccounts] = useState<
    Array<{
      idAccount: number
      accountId: string;
      index: number;
      initial_balance: number;
      current_balance_formatted: string;
      current_equity_formatted: string;
      current_pnl_formatted: string;
      todays_profit_formatted: string;
      current_equity: number;
      current_balance: number;
      current_pnl: number;
      todays_profit: number;
      created_at: string;
      status: "active" | "inactive" | "suspended";
      accountType: "admin" | "user" | "guest";
      accountLevel: "basic" | "premium" | "enterprise";
      endDate: Date;
      loginCredentials: {
        loginID: string;
        masterPassword: string;
        readOnlyPassword: string;
      };
      currency?: string;
      perfomance: {
        profit: number;
        Equity: number;
        PnL: number;
      };
      platform: string;
      user: {
        userId: string;
        userName: string;
        broker: string;
      };
    }>
  >();
  const [openfillter, setOpenfillter] = useState<boolean>(false);
  const [filterPlatform, setFilterPlatform] = useState<string>('All');
  const [filterBroker, setFilterBroker] = useState<string>('All');
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [sortOption, setSortOption] = useState<"balance" | "create_at" | "profit" | null>(null);
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("desc");

  function getRedirectUrl(url: string): string | null {
    // Matches 'redirect_url=' followed by everything up to the next '&' or the end of the string
    const match = url.match(/[?&]redirect_url=([^&#]*)/);

    if (!match) {
      return null;
    }

    // decodeURIComponent handles any URL encoding (e.g., %2F instead of /)
    return decodeURIComponent(match[1]);
  }

  // Auto redirect for local store variable
  useEffect(() => {
    const redirect_url = localStorage.getItem('redirect_url');
    console.log("Redirect URL:", redirect_url);
    if (redirect_url && redirect_url.length > 0) {
      localStorage.removeItem('redirect_url')
      window.location.href = redirect_url
    }
  }, [])


  async function filterAccounts(platform?: string, broker?: string, search?: string, sortOption?: string, sortDirection?: string) {
    fetch(API_URL + `/api/v1/be/trade_accounts?user_id=${userId}&page=${1}&limit=${tradeAccountNumber}${platform ? `&platform=${platform}` : ""}${broker ? `&broker=${broker}` : ""}${search ? `&name=${search}` : ""}${sortOption ? `&sort_by=${sortOption}` : ""}${sortDirection ? `&direction=${sortDirection}` : ""}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Assuming the API returns an array of accounts in data.items
        const accounts = data?.data?.items || [];
        setTotalPage(data.data?.total || 0)
        setUserLevelAccounts(
          accounts.map((account: any, index: number) => ({
            idAccount: account.id,
            accountId: account.account_number,
            initial_balance: account.initial_balance || 0,
            current_balance_formatted: account.trading_stats.current_balance_formatted,
            current_equity_formatted: account.trading_stats.current_equity_formatted,
            current_pnl_formatted: account.trading_stats.current_pnl_formatted,
            todays_profit_formatted: account.trading_stats.todays_profit_formatted,
            current_equity: account.trading_stats.current_equity,
            current_balance: account.trading_stats.current_balance,
            current_pnl: account.trading_stats.current_pnl,
            todays_profit: account.trading_stats.todays_profit,
            created_at: account.created_at,
            index: index,
            accountBalance: account.balance || 0,
            status: "active",
            accountType: "user",
            accountLevel: "basic",
            endDate: new Date(account.created_at),
            loginCredentials: {
              loginID: account.account_number,
              masterPassword: account.account_password,
              readOnlyPassword: "", // No readonly password in API
            },
            currency: "USD",
            perfomance: {
              profit: 0,
              Equity: 0,
              PnL: 0,
            },
            platform: account.platform,
            user: {
              userId: account.account_number,
              userName: account.nickname || "Unknown User",
              broker: account.broker || "Unknown Broker",
            },
          }))
        );
        userData = accounts.map((account: any) => ({
          accountId: account.account_number,
          masterPassword: account.account_password,
          readOnlyPassword: "",
          platform: account.platform,
          broker: account.broker || "Unknown Broker",
        }));
      })
      .catch((error) => { console.error("Error fetching accounts:", error); });
  }
  useEffect(() => {
    const delay = setTimeout(() => {
      if (filterPlatform === 'All' && filterBroker === 'All' && !searchFilter && !sortOption) {
        getData();
        return;
      }

      const platform = filterPlatform !== 'All' ? filterPlatform : undefined;
      const broker = filterBroker !== 'All' ? filterBroker : undefined;
      const search = searchFilter?.trim() ? searchFilter : undefined;
      const sort = sortOption ? sortOption : undefined;
      const direction = sortDirection ? sortDirection : undefined;

      filterAccounts(platform, broker, search, sort, direction);
    }, 300);

    return () => clearTimeout(delay);
  }, [filterPlatform, filterBroker, searchFilter, sortOption, sortDirection]);

  useEffect(() => {
    const data = localStorage.getItem('user')

    if (data) {
      const idData = JSON.parse(data).id
      setUserId(idData)
    }

    getUnreadCount().then(count => {
      setNotificationUnreadLength(count);
    });
  }, [])
  const handleShowModalCredentials = (value: boolean, accountId: string) => {
    setIsShowModalCredentials(value);
    setSelectedAccount(accountId);
  };
  async function onSaveNewAccount(
    accountId: string,
    nickname: string,
    balanceSize: string,
    platform: string,
    broker: string,
    accountType?: string
  ) {
    try {
      if (!accountId || !nickname || !balanceSize || !platform || !broker) {
        notification.error('Please fill all fields');
        return;
      }
      // if (isNaN(parseFloat(balanceSize)) || parseFloat(balanceSize) <= 0) {
      //   toast.error('Balance size must be a positive number', {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: false,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "light",
      //   });
      //   return;
      // }
      if (userData.some((item) => item.accountId === accountId)) {
        const updateAccount = userLevelAccounts?.find((item) => item.accountId === accountId);
        const updateInfo = await fetch(API_URL + `/api/v1/be/trade_account/${updateAccount?.idAccount}?nickname=${nickname}&balance_size=${parseFloat(balanceSize)}&platform=${platform}&broker=${broker}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        )
        if (updateInfo.status) {
          notification.success('Updated account information');
          const count = countUpdate + 1
          setCountUpdate(count)
          setNewAccountModal(false);
        } else {
          notification.error('There is an error');
        }
        return;
      }
      const hasStatus = accountType && accountType.trim() !== '';

      const res2 = await mixPostV2(`/terminal-accounts`, {
        login_id: accountId,
        app_type: platform,
        broker: broker,
        balance: parseFloat(balanceSize),
        nickname: nickname,
        ...(hasStatus && { account_status: accountType }), // Chỉ map vào nếu hasStatus đúng
      });

      const res = await mixPostV1(`/api/v1/be/trade_account`, {
        account_number: accountId,
        nickname: nickname,
        balance: parseFloat(balanceSize),
        initial_balance: parseFloat(balanceSize),
        platform: platform,
        broker: broker,
        user_id: userId,
        ...(hasStatus && { account_status: accountType }), // Chỉ map vào nếu hasStatus đúng
      });
      if (!res.status || !res2.status) {
        notification.error(`Error: ${res.detail[0].msg || res2.msg}`);

        setNewAccountModal(false);
        return;
      }



      // if (!response.ok) {
      //   throw new Error("Failed to create account");
      // }
      // const data = await response.json();
      // if (data.success) {
      //   setUserLevelAccounts((prevAccounts = []) => [
      //     ...prevAccounts,
      //     {
      //       idAccount: 1,
      //       accountId: accountId,
      //       index: prevAccounts.length,
      //       accountBalance: 0,
      //       status: "active",
      //       accountType: "user",
      //       accountLevel: "basic",
      //       endDate: new Date(),
      //       loginCredentials: {
      //         loginID: accountId,
      //         masterPassword: masterPassword,
      //         readOnlyPassword: readOnlyPassword,
      //       },
      //       currency: "USD",
      //       perfomance: {
      //         profit: 0,
      //         Equity: 0,
      //         PnL: 0,
      //       },
      //       platform: platform,
      //       user: {
      //         userId: accountId,
      //         userName: "New User",
      //       },
      //     },
      //   ]);
      //   userData.push({
      //     accountId: accountId,
      //     masterPassword: masterPassword,
      //     readOnlyPassword: readOnlyPassword,
      //     platform: platform,
      //   });
      // } else {
      //   throw new Error("Failed to create account");
      // }

      if (res.status && res2.status) {
        notification.success('Created a new account');

        setNewAccountModal(false);
        const count = countUpdate + 1
        setCountUpdate(count)

      }
    } catch (error) {
      console.error("Error creating new account:", error);
      notification.error('There is an error');
    }
  }


  // Function to delete an account ( unstable )
  const deleteAccount = async (id: number, platform: string, account_number: string) => {
    const token = localStorage.getItem('token')
    const res = await fetch(API_URL + `/api/v1/be/trade_account/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      method: "DELETE",
    })
    const botRes = await fetch(`https://lumir.ccpi.vn/api/docker/status/${platform}/${account_number}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "QH3C2JbUzkYt1sfz96VTn_slED9V81-V9wy1eUUU1-M",
      },
    })

    if (botRes.ok && botRes.status === 200) {
      const botData = await botRes.json();
      const containerId = botData?.status?.ID;
      if (containerId) {
        await fetch(`https://lumir.ccpi.vn/api/docker/remove`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "QH3C2JbUzkYt1sfz96VTn_slED9V81-V9wy1eUUU1-M",
          },
          body: JSON.stringify({ container_id: containerId }),
        });

        await fetch(`https://lumir.ccpi.vn/api/db/remove`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "QH3C2JbUzkYt1sfz96VTn_slED9V81-V9wy1eUUU1-M",
          },
          body: JSON.stringify({ account: account_number, platform: platform }),
        });
      }
    }

    if (res.status) {
      notification.success('Deleted Successful');

      const count = countUpdate + 1
      setCountUpdate(count)
    } else {
      notification.error('There is an error');
    }
  }

  const getData = async () => {
    const token = localStorage.getItem('token')
    if (!userId) {
      return;
    }
    setStatus('loading');
    fetch(API_URL + `/api/v1/be/trade_accounts?user_id=${userId}&page=${currentPage}&limit=${tradeAccountNumber}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token || ''}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Assuming the API returns an array of accounts in data.items
        const accounts = data?.data?.items || [];
        setTotalPage(data.data?.total || 0)
        setUserLevelAccounts(
          accounts.map((account: any, index: number) => ({
            idAccount: account.id,
            accountId: account.account_number,
            initial_balance: account.initial_balance || 0,
            current_balance_formatted: account.trading_stats.current_balance_formatted,
            current_equity_formatted: account.trading_stats.current_equity_formatted,
            current_pnl_formatted: account.trading_stats.current_pnl_formatted,
            todays_profit_formatted: account.trading_stats.todays_profit_formatted,
            current_equity: account.trading_stats.current_equity,
            current_balance: account.trading_stats.current_balance,
            current_pnl: account.trading_stats.current_pnl,
            todays_profit: account.trading_stats.todays_profit,
            created_at: account.created_at,
            index: index,
            accountBalance: account.balance || 0,
            status: "active",
            accountType: account.account_status || "No status",
            accountLevel: "basic",
            endDate: new Date(account.created_at),
            loginCredentials: {
              loginID: account.account_number,
              masterPassword: account.account_password,
              readOnlyPassword: "", // No readonly password in API
            },
            currency: "USD",
            perfomance: {
              profit: 0,
              Equity: 0,
              PnL: 0,
            },
            platform: account.platform,
            user: {
              userId: account.account_number,
              userName: account.nickname || "Unknown User",
              broker: account.broker || "Unknown Broker",
            },
          }))
        );
        userData = accounts.map((account: any) => ({
          accountId: account.account_number,
          masterPassword: account.account_password,
          readOnlyPassword: "",
          platform: account.platform,
          broker: account.broker || "Unknown Broker",
        }));
        setStatus('success');
      })
      .catch((error) => { console.error("Error fetching accounts:", error); setStatus('error'); });

  }

  const updateData = async () => {
    const token = localStorage.getItem('token')
    fetch(API_URL + `/api/v1/be/trade_accounts?user_id=${userId}&page=${currentPage}&limit=${tradeAccountNumber}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token || ''}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Assuming the API returns an array of accounts in data.items
        const accounts = data?.data?.items || [];
        setTotalPage(data.data?.total || 0)
        setUserLevelAccounts(
          accounts.map((account: any, index: number) => ({
            idAccount: account.id,
            accountId: account.account_number,
            initial_balance: account.initial_balance || 0,
            current_balance_formatted: account.trading_stats.current_balance_formatted,
            current_equity_formatted: account.trading_stats.current_equity_formatted,
            current_pnl_formatted: account.trading_stats.current_pnl_formatted,
            todays_profit_formatted: account.trading_stats.todays_profit_formatted,
            current_equity: account.trading_stats.current_equity,
            current_balance: account.trading_stats.current_balance,
            current_pnl: account.trading_stats.current_pnl,
            todays_profit: account.trading_stats.todays_profit,
            created_at: account.created_at,
            index: index,
            accountBalance: account.balance || 0,
            status: "active",
            accountType: "user",
            accountLevel: "basic",
            endDate: new Date(account.created_at),
            loginCredentials: {
              loginID: account.account_number,
              masterPassword: account.account_password,
              readOnlyPassword: "", // No readonly password in API
            },
            currency: "USD",
            perfomance: {
              profit: 0,
              Equity: 0,
              PnL: 0,
            },
            platform: account.platform,
            user: {
              userId: account.account_number,
              userName: account.nickname || "Unknown User",
              broker: account.broker || "Unknown Broker",
            },
          }))
        );
        userData = accounts.map((account: any) => ({
          accountId: account.account_number,
          masterPassword: account.account_password,
          readOnlyPassword: "",
          platform: account.platform,
          broker: account.broker || "Unknown Broker",
        }));
        setStatus('success');
      })
      .catch((error) => { console.error("Error fetching accounts:", error); setStatus('error'); });

  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (!userId) return;

      const platform = filterPlatform !== 'All' ? filterPlatform : undefined;
      const broker = filterBroker !== 'All' ? filterBroker : undefined;
      const search = searchFilter?.trim() ? searchFilter : undefined;
      const sort = sortOption ? sortOption : undefined;
      const direction = sortDirection ? sortDirection : undefined;

      if (filterPlatform === 'All' && filterBroker === 'All' && !searchFilter && !sortOption) {
        updateData();
      } else {
        filterAccounts(platform, broker, search, sort, direction);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [userId, currentPage, filterPlatform, filterBroker, searchFilter, sortOption, sortDirection]);

  useEffect(() => {
    getData();
    const el = document.querySelector('.page');
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, [currentPage, countUpdate]);

  return (
    <Layout>
      <Helmet>
        <title>
          {notificationUnreadLength === 0
            ? ''
            : `(${notificationUnreadLength}) `}
          Accounts Overview</title>
        <meta name="description" content="Overview of all accounts" />
        <link rel="canonical" href="/accounts-overview" />
        <meta property="og:title" content="Accounts Overview" />
        <meta property="og:description" content="Overview of all accounts" />
      </Helmet>
      <div className="accounts-overview _tw" style={{ background: 'var(--bg-sub)', minHeight: '100vh', color: 'var(--text-title)' }}>
        <nav className="breadcrumb__container" style={{ borderBottom: '1px solid var(--card-border)' }}>
          <div
            className="breadcrumb__gradient breadcrumb__gradient--left"
            data-gradient="left"
            style={{ display: "none" }}
          ></div>
          <ul className="breadcrumb" data-breadcrumb-scroll-container="">
            <li className="breadcrumb-item">
              <a href="/accounts-overview" style={{ color: 'var(--text-desc)' }}>{t('Trader')}</a>
            </li>
            <li className="breadcrumb-item active" style={{ color: 'var(--text-title)' }}>{t('AccsOverview')}</li>
          </ul>
          <div
            className="breadcrumb__gradient breadcrumb__gradient--right"
            data-gradient="right"
            style={{ display: "none" }}
          ></div>
        </nav>

        <div className="_sectionHeaderItem_1aplf_3">
          <div className="_mainSectionContainer_1aplf_56">
            <div className="_itemTitleWrapper_1aplf_32">
              <div className="flex flex-col md:flex-row md:justify-between gap-4 justify-start w-full">
                <div className="flex items-center gap-3">
                  <div
                    className="relative flex size-4 items-center justify-center -mr-2"
                    data-sentry-component="Pulse"
                    data-sentry-source-file="Pulse.tsx"
                  >
                    <div className="_animation_unxb2_3 bg-symbol-badge-success-opacity absolute inset-0 rounded-full"></div>
                    <div className="bg-symbol-badge-success-full size-[4px] flex-shrink-0 rounded-full"></div>
                  </div>
                  <h6 className="_itemTitle_1aplf_17 text-headings-h6 md:!text-sm !text-[10px] m-0">
                    {t('Activeaccounts')} ({totalPage})
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* search for account */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
          {/* Search Input */}
          <div style={{ flex: 1, position: 'relative', minWidth: '220px', maxWidth: '400px' }}>
            <Search
              size={15}
              style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-desc)' }}
            />
            <input
              type="text"
              value={searchFilter}
              onChange={(e) => setSearchFilter(e.target.value)}
              placeholder={t('search_for_account') + '...'}
              style={{
                width: '100%',
                padding: '9px 14px 9px 34px',
                border: '1px solid var(--card-border)',
                borderRadius: '8px',
                fontSize: '13.5px',
                outline: 'none',
                background: 'var(--card-bg)',
                color: 'var(--text-title)'
              }}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            {/* Filter Button */}
            <button
              onClick={() => setOpenfillter(!openfillter)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                background: 'var(--card-bg)',
                border: '1px solid var(--card-border)',
                borderRadius: '8px',
                padding: '9px 13px',
                fontSize: '13px',
                fontWeight: 600,
                color: 'var(--text-title)',
                cursor: 'pointer'
              }}
            >
              <Filter size={14} style={{ color: 'var(--text-desc)' }} />
              {t('filter')}
            </button>

            {/* Sort Button (View mode sort) */}
            <button
              className={`${viewMode === 'sort' ? 'active' : ''}`}
              onClick={() => setViewMode(viewMode === 'sort' ? 'grid' : 'sort')}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                background: viewMode === 'sort' ? 'var(--active-btn-bg)' : 'var(--card-bg)',
                border: '1px solid var(--card-border)',
                borderRadius: '8px',
                padding: '9px 13px',
                fontSize: '13px',
                fontWeight: 600,
                color: viewMode === 'sort' ? 'var(--active-btn-text)' : 'var(--text-title)',
                cursor: 'pointer'
              }}
            >
              <ArrowUpDown size={14} style={{ color: viewMode === 'sort' ? 'var(--active-btn-text)' : 'var(--text-desc)' }} />
              {t('sort')}
            </button>

            <button
              onClick={() => {
                setFilterPlatform('All');
                setFilterBroker('All');
                setSearchFilter('');
                setSortOption(null);
              }}
              style={{
                width: '34px',
                height: '34px',
                background: 'var(--card-bg)',
                border: '1px solid var(--card-border)',
                borderRadius: '8px',
                color: 'var(--text-title)',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <RotateCw size={15} style={{ color: 'var(--text-desc)' }} />
            </button>

            <button
              style={{
                width: '34px',
                height: '34px',
                background: 'var(--card-bg)',
                border: '1px solid var(--card-border)',
                borderRadius: '8px',
                color: 'var(--text-title)',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Download size={15} style={{ color: 'var(--text-desc)' }} />
            </button>

            <div style={{ display: 'flex', border: '1px solid var(--card-border)', borderRadius: '8px', overflow: 'hidden', marginLeft: '2px', flexShrink: 0 }}>
              <button
                onClick={() => setViewMode('list')}
                style={{
                  border: 'none',
                  padding: '8px 14px',
                  fontSize: '12.5px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  background: viewMode === 'list' ? 'var(--active-btn-bg)' : 'var(--card-bg)',
                  color: viewMode === 'list' ? 'var(--active-btn-text)' : 'var(--text-desc)'
                }}
              >
                <List size={14} />
                List
              </button>
              <button
                onClick={() => setViewMode('grid')}
                style={{
                  border: 'none',
                  padding: '8px 14px',
                  fontSize: '12.5px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  background: (viewMode === 'grid' || viewMode === 'sort') ? 'var(--active-btn-bg)' : 'var(--card-bg)',
                  color: (viewMode === 'grid' || viewMode === 'sort') ? 'var(--active-btn-text)' : 'var(--text-desc)'
                }}
              >
                <LayoutGrid size={14} />
                Grid
              </button>
            </div>
          </div>
          <button
            onClick={() => setNewAccountModal(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              background: 'var(--primary-btn-bg)',
              color: 'var(--primary-btn-text)',
              border: 'none',
              fontWeight: 700,
              fontSize: 13,
              padding: '5px 16px',
              borderRadius: '8px',
              cursor: 'pointer',
              marginLeft: 'auto',
            }}
          >
            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>+</span>
            {t('Addnewaccount')}
          </button>
        </div>

        {
          openfillter && (
            <>
              <div className="flex px-8 w-full search-toolbar-separator h-[1px] my-4" />
              <div className="mt-4">
                <FillterOptions
                  selectedBroker={filterBroker}
                  setSelectedBroker={setFilterBroker}
                  selectedPlatform={filterPlatform}
                  setSelectedPlatform={setFilterPlatform}
                  sortOption={sortOption}
                  setSortOption={setSortOption}
                  sortDirection={sortDirection}
                  setSortDirection={setSortDirection}
                />
              </div>
            </>
          )
        }


        {/* Danh sách tài khoản con */}

        <div className="mt-6" data-sentry-component="AccountList" data-sentry-source-file="AccountList.tsx">
          {status === "success" ? (
            <>
              {viewMode === 'grid' && (
                <div className="grid grid-cols-1 xl:!grid-cols-2 gap-4">
                  {(userLevelAccounts ?? [])
                    .map((account, index) => (
                      <AccountDetail
                        key={account.idAccount}
                        idAccount={account.idAccount}
                        accountId={account.accountId}
                        initial_balance={account.initial_balance}
                        current_balance_formatted={account.current_balance_formatted}
                        current_equity_formatted={account.current_equity_formatted}
                        current_pnl_formatted={account.current_pnl_formatted}
                        todays_profit_formatted={account.todays_profit_formatted}
                        current_equity={account.current_equity}
                        current_balance={account.current_balance}
                        current_pnl={account.current_pnl}
                        todays_profit={account.todays_profit}
                        index={index}
                        status={account.status}
                        accountType={account.accountType}
                        accountLevel={account.accountLevel}
                        created_at={account.created_at}
                        endDate={account.endDate}
                        loginCredentials={account.loginCredentials}
                        perfomance={account.perfomance}
                        platform={account.platform}
                        currency={account.currency}
                        user={account.user}
                        onUpdate={() => {
                          const count = countUpdate + 1
                          setCountUpdate(count)
                        }}
                        setVisible={
                          (value: boolean) => {
                            if (value) {
                              setNotVisibleList(notVisibleList.filter((item) => item !== account.accountId));
                            } else {
                              setNotVisibleList([...notVisibleList, account.accountId]);
                            }
                          }
                        }
                        visible={!notVisibleList.includes(account.accountId)}
                        setIsShowModalCredentials={(value, accountId) =>
                          handleShowModalCredentials(value, accountId)
                        }
                        deleteAccount={deleteAccount}
                      />
                    ))}
                </div>
              )}

              {viewMode === 'list' && (
                <AccountListView
                  accounts={(userLevelAccounts ?? []).filter(
                    (account) => !notVisibleList.includes(account.accountId),
                  )}
                  onEdit={(account) => {
                    setEditingAccount({
                      accountId: account.idAccount,
                      account_number: account.accountId,
                      nickName: account.user?.userName || 'Unknown User',
                      balanceSize: account.initial_balance || 0,
                      platform: account.platform || 'Unknown Platform',
                      broker: account.user?.broker || 'Unknown Broker',
                      accountType: "",
                    })
                    setIsEditModalOpen(true)
                  }}
                  onDelete={deleteAccount}
                />
              )}

              {viewMode === 'sort' && (
                <AccountSortView
                  accounts={(userLevelAccounts ?? [])
                    .filter((account) => !notVisibleList.includes(account.accountId))
                    .slice()
                    .sort((a, b) => (b.todays_profit || 0) - (a.todays_profit || 0))}
                  onEdit={(account) => {
                    setEditingAccount({
                      accountId: account.idAccount,
                      account_number: account.accountId,
                      nickName: account.user?.userName || 'Unknown User',
                      balanceSize: account.initial_balance || 0,
                      platform: account.platform || 'Unknown Platform',
                      broker: account.user?.broker || 'Unknown Broker',
                      accountType: "",
                    })
                    setIsEditModalOpen(true)
                  }}
                  onDelete={deleteAccount}
                />
              )}
            </>
          ) : status === "loading" ? (
            <div className="flex items-center justify-center h-64">
              <p className="text-content-primary text-headings-h6">
                {t('Loadingaccounts')}
              </p>
            </div>
          ) : (
            <div className="flex items-center justify-center h-64">
              <p className="text-content-primary text-headings-h6">
                {t('Errorloadingaccounts')}
              </p>
            </div>
          )}
        </div>
        <Pagination
          className="mt-6"
          current={currentPage}
          total={totalPage}
          align="center"
          pageSize={tradeAccountNumber}
          onChange={(page) => {
            setCurrentPage(page);
            window.scrollTo({ top: 0, behavior: "smooth" });

          }}
          showSizeChanger={false}
          showLessItems={true}
          showTitle={false}
          hideOnSinglePage={true}
        />

        <Footer data={userLevelAccounts} />
        {isShowModalCredentials && (
          <CredentialsModal
            accountId={selectedAccount}
            setIsShowModalCredentials={() =>
              setIsShowModalCredentials(!isShowModalCredentials)
            }
          />
        )}
        {newAccountModal && (
          <NewAccountCredentials
            onClose={() => setNewAccountModal(!newAccountModal)}
            onSave={async (value) => {
              if (!value) return;
              await onSaveNewAccount(
                value.accountId,
                value.nickName,
                value.balanceSize.toString(),
                value.platform,
                value.broker,
                value.accountType
              );
            }}
          />
        )}
        {editingAccount && (
          <Modal
            title={`${t('EditAccount')} ${editingAccount.accountId}`}
            open={isEditModalOpen}
            onCancel={() => setIsEditModalOpen(false)}
            footer={null}
            width={600}
            zIndex={1000}
          >
            <EditAccount
              onClose={() => setIsEditModalOpen(false)}
              onSave={(value) => {
                console.log('Edit account from list view:', value)
                setIsEditModalOpen(false)
              }}
              account={editingAccount}
            />
          </Modal>
        )}
      </div>
    </Layout>
  );
};
export default Dashboard;

const Footer = (props: any) => {

  const { data } = props
  const { t } = useTranslation();
  const [options, setOptions] = useState<any>()


  useEffect(() => {
    const handleData = data?.map((item: any) => ({
      label: item.accountId,
      value: item.accountId
    }))

    setOptions(handleData)
  }, [data])

  const [checkedList, setCheckedList] = useState<any>('');
  const [file, setFile] = useState<File | null>(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [listBots, setListBots] = useState<any>()
  const [botSelected, setBotelected] = useState<number>()
  const [isDownload, setisDownload] = useState<boolean>(false)
  const [showUploadExcel, setShowUploadExcel] = useState<boolean>(false)
  const [isImport, setIsImport] = useState<boolean>(false)



  const handleChange = (e: any) => {
    setCheckedList(e.target.value);
  };

  const showUpload = () => {
    setShowUploadExcel(true)
  }

  const cancelShowUpload = () => {
    setShowUploadExcel(false)
  }

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const tradeHistoryImport = async (): Promise<void> => {
    setIsImport(true)
    if (!file || checkedList === null) {
      message.error('Vui lòng chọn file và nhập mã tài khoản.');
      setIsImport(false)
      return;
    }

    const authToken = localStorage.getItem('token');

    if (!authToken) {
      message.error('Không tìm thấy token xác thực. Vui lòng đăng nhập lại.');
      setIsImport(false)
      return;
    }

    const formData = new FormData();
    formData.append('excel_file', file);
    formData.append('account_number', checkedList)

    try {
      const response = await axios.post(
        `${API_URL}/api/v1/be/trade-history/import`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
          },
        }
      );

      setIsImport(false)
      setShowUploadExcel(false)

      // setCheckedList(prev => prev.slice(1));

      message.success('File đã được upload thành công.');
    } catch (error: unknown) {
      setIsImport(false)
      console.error('Lỗi khi upload file:', error);

      if (axios.isAxiosError(error)) {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            message.error('Token không hợp lệ hoặc đã hết hạn. Vui lòng đăng nhập lại.');
          } else {
            const errorMessage = (error.response.data as { message?: string })?.message || 'Có lỗi xảy ra từ server.';
            message.error(errorMessage);
          }
        } else if (error.request) {
          message.error('Không thể kết nối đến server. Vui lòng kiểm tra lại kết nối mạng.');
        } else {
          message.error('Lỗi khi gửi request.');
        }
      } else {
        message.error('Đã xảy ra lỗi không xác định.');
      }
    } finally {
      setIsImport(false)
    }
  }

  const downloadBot = async () => {
    setisDownload(true)
    if (botSelected) {
      const res = await mixPostV1(`/api/v1/be/bots/${botSelected}/download`, {
        id: botSelected
      })

      if (res.status) {
        window.open(res.data.download_url, "_blank");
        setisDownload(false)
      } else {
        message.error('There is an error. please try again')
        setisDownload(false)
      }
    } else {
      message.error('Please select a bot')
      setisDownload(false)
    }
  }

  const getData = async () => {
    const res = await mixGetV1('/api/v1/be/bots')

    if (res.status) {
      setListBots(res.data)
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#recommendation") {
      const el = document.getElementById("recommendation");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);


  return (
    <>
      <div className="mt-6" id="recommendation">
        <h3 className="m-0 mb-2 text-headings-h3 text-content-primary">
          {t('ConnectToYourTraderAccount')}
        </h3>
        <p>
          {t('ConnectToYourTraderAccountDesc')}
        </p>
        <div
          className="grid grid-cols-1 gap-6 md:grid-cols-2"
          data-sentry-component="PotentialAccount"
          data-sentry-source-file="PotentialAccount.tsx"
        >
          {/* first card */}
          <div
            className="relative flex h-full flex-col justify-between overflow-hidden rounded-[4px] bg-background-secondary px-3 py-6 text-center"
            data-sentry-component="PotentialAccountBox"
            data-sentry-source-file="PotentialAccountBox.tsx"
          >
            <div className="pointer-events-none absolute left-[0px] top-0">
              <div
                className="_gradientWrapper_vdvau_18 _large_vdvau_3 bg-functional-active left-[-10px] top-[-100px]"
                data-sentry-component="Gradient"
                data-sentry-source-file="Gradient.tsx"
              ></div>
              <div className="relative bottom-[140px] right-[250px]">
                <svg
                  width="441"
                  height="322"
                  viewBox="0 0 441 322"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  data-sentry-element="OrnamentsBoldIcon"
                  data-sentry-source-file="PotentialAccountBox.tsx"
                >
                  <g opacity="0.35">
                    <path
                      d="M301.514 235.324L301.773 235.048L301.514 234.772L258.301 188.857V149.136L339.157 235.048L258.301 320.986V281.265L301.514 235.324ZM166.383 235.074L247.239 149.136V188.857L185.062 254.922L166.383 235.074ZM221.564 293.68L247.239 266.375V320.959L221.564 293.68ZM193.729 264.102L247.241 207.244V247.935L212.877 284.448L193.729 264.102Z"
                      stroke="#E9B460"
                      strokeWidth="0.805"
                    ></path>
                  </g>
                  <g opacity="0.07">
                    <path
                      d="M135.684 198.293L135.943 198.017L135.684 197.741L92.471 151.826V112.105L173.327 198.017L92.471 283.955V244.233L135.684 198.293ZM0.55269 198.043L81.409 112.105V151.826L19.2324 217.891L0.55269 198.043ZM55.7343 256.649L81.4086 229.344V283.928L55.7343 256.649ZM27.8988 227.071L81.4107 170.213V210.904L47.047 247.416L27.8988 227.071Z"
                      stroke="#E9B460"
                      strokeWidth="0.805"
                    ></path>
                  </g>
                  <g opacity="0.08">
                    <path
                      d="M402.139 129.062L402.398 128.786L402.139 128.51L358.926 82.5957V42.8743L439.782 128.786L358.926 214.724V175.003L402.139 129.062ZM267.008 128.812L347.864 42.8746V82.5957L285.687 148.66L267.008 128.812ZM322.189 187.418L347.864 160.113V214.698L322.189 187.418ZM294.354 157.84L347.866 100.983V141.674L313.502 178.186L294.354 157.84Z"
                      stroke="#E9B460"
                      strokeWidth="0.805"
                    ></path>
                  </g>
                  <g opacity="0.1">
                    <path
                      d="M239.529 87.2027L239.788 86.9268L239.528 86.651L196.316 40.7364V1.01496L277.172 86.9269L196.316 172.865V133.144L239.529 87.2027ZM104.397 86.953L185.254 1.01518V40.7364L123.077 106.801L104.397 86.953ZM159.579 145.559L185.253 118.254V172.838L159.579 145.559ZM131.744 115.981L185.255 59.1234V99.8141L150.892 136.326L131.744 115.981Z"
                      stroke="#E9B460"
                      strokeWidth="0.805"
                    ></path>
                  </g>
                </svg>
              </div>
            </div>
            <div>
              <div className="grid justify-center">
                <span className="flex w-fit justify-center rounded-[5px] border-solid border-border-secondary p-3 text-content-active">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="80"
                    height="80"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-bot-message-square-icon lucide-bot-message-square">
                    <path d="M12 6V2H8" />
                    <path d="M15 11v2" />
                    <path d="M2 12h2" />
                    <path d="M20 12h2" />
                    <path d="M20 16a2 2 0 0 1-2 2H8.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 4 20.286V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z" />
                    <path d="M9 11v2" />
                  </svg>
                </span>
              </div>
              <h3 className="mx-8 mb-2 text-headings-h4 text-content-primary">
                {t('installBot')}
              </h3>
              <div className="mx-8 mb-2 text-headings-headline text-functional-active">
                {t('installBotDesc')}
              </div>
              {/* <div className="mx-5 mb-3 text-body-small text-content-tertiary">
                Complete to unlock personalized reports 
                & earn extra bonus points!
              </div> */}
            </div>
            <ul className="mb-0 list-none px-6">
              <li className="align-start mb-4 flex items-center gap-3 text-left text-buttons-large text-content-secondary last:mb-0">
                <div
                  aria-hidden="true"
                  className="_svgXs_12opb_18 p-[6px] rounded-[4px] bg-symbol-badge-primary-opacity text-symbol-badge-primary-full h-fit w-fit leading-[0px]"
                  data-sentry-component="FunctionalIcon"
                  data-sentry-source-file="FunctionalIcon.tsx"
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 12H19M12 5L19 12L12 19"
                      stroke="currentColor"
                      strokeWidth="4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                {t('installBotDesc2')}
              </li>
              <li className="align-center mb-4 flex items-center gap-3 text-left text-buttons-large text-content-secondary last:mb-0">
                <div
                  aria-hidden="true"
                  className="_svgXs_12opb_18 p-[6px] rounded-[4px] bg-symbol-badge-primary-opacity text-symbol-badge-primary-full h-fit w-fit leading-[0px]"
                  data-sentry-component="FunctionalIcon"
                  data-sentry-source-file="FunctionalIcon.tsx"
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 4V20M4 12H20"
                      stroke="currentColor"
                      strokeWidth="4"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                {t('installBotDesc3')}
              </li>
              <li className="align-center mb-4 flex items-center gap-3 text-left text-buttons-large text-content-secondary last:mb-0">
                <div
                  aria-hidden="true"
                  className="_svgXs_12opb_18 p-[6px] rounded-[4px] bg-symbol-badge-primary-opacity text-symbol-badge-primary-full h-fit w-fit leading-[0px]"
                  data-sentry-component="FunctionalIcon"
                  data-sentry-source-file="FunctionalIcon.tsx"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.7209 3L8.60465 14.8446L4.30232 10.2604L1 13.7791L8.60465 21.8571L23 6.51868L19.7209 3Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                {t('installBotDesc4')}
              </li>
            </ul>
            {/* <a
              href="/"
              className="_button_rcmwj_3 _size-large_rcmwj_242 _type-primary_rcmwj_31 _kind-filled_rcmwj_31 relative z-0 mt-3 text-black _fullWidth_rcmwj_278"
            >
              Get Points Now
            </a> */}
            <button
              className="px-2 py-2 no-underline sm:text-[10px] md:text-[12px] text-[14px] rounded-md relative z-0 mt-3 bg-[#e9b460] text-black outline outline-2 outline-[#e9b460] outline-offset-0 _fullWidth_rcmwj_278"
              onClick={showModal}
            >
              {t('installBotNow')}
            </button>
          </div>

          <Modal
            title="Download bot"
            open={isModalOpen}
            onCancel={handleCancel}
            footer={[
              <Button key="close" onClick={handleCancel}>
                {t("Close")}
              </Button>,
            ]}
          >
            <p className="mb-3 text-gray-600">
              {t('selectBotDownload')}
            </p>
            <Select
              placeholder="Choose a platform"
              style={{ width: "100%" }}
              onChange={(value) => setBotelected(value)}
            >
              {listBots && listBots.map((item: any) => (
                <Option key={item.id} value={item.id}><span style={{ color: "black" }}>{item.name}</span></Option>
              ))}
            </Select>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <div >
                {listBots && botSelected
                  ? (() => {
                    const bot = listBots.find((bot: any) => bot.id === botSelected);
                    if (bot) {
                      if (bot.name?.toUpperCase().includes("MT4") || bot.name?.toUpperCase().includes("MT5")) {
                        return (
                          <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                            {t('downloadBotMTDesc')}{" "}
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                navigator.clipboard.writeText("https://ftmo-real-api.buso.asia");
                                message.success(t('linkcopySuccess'));
                              }}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#1890ff", textDecoration: "underline", marginBottom: "8px", display: "inline-block" }}
                            >
                              https://ftmo-real-api.buso.asia
                            </a>
                          </div>
                        );
                      }
                      return null;
                    }
                    return null;
                  })()
                  : null}
              </div>
              {
                listBots && botSelected ? (
                  <Button style={{ marginTop: '16px', backgroundColor: '#E9B460', cursor: isDownload ? 'not-allowed' : 'pointer', pointerEvents: isDownload ? 'none' : 'all', opacity: isDownload ? '0.3' : '1' }} onClick={downloadBot}>
                    <span style={{ color: 'white' }}>{t("Download")}</span>
                  </Button>
                ) : null
              }
            </div>
          </Modal>

          {/* second card */}
          <div
            className="relative flex h-full flex-col justify-between overflow-hidden rounded-[4px] bg-background-secondary px-3 py-6 text-center"
            data-sentry-component="PotentialAccountBox"
            data-sentry-source-file="PotentialAccountBox.tsx"
          >
            <div className="pointer-events-none absolute left-[0px] top-0">
              <div
                className="_gradientWrapper_vdvau_18 _large_vdvau_3 bg-functional-active left-[-10px] top-[-100px]"
                data-sentry-component="Gradient"
                data-sentry-source-file="Gradient.tsx"
              ></div>
              <div className="relative bottom-[140px] right-[250px]">
                <svg
                  width="441"
                  height="322"
                  viewBox="0 0 441 322"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  data-sentry-element="OrnamentsBoldIcon"
                  data-sentry-source-file="PotentialAccountBox.tsx"
                >
                  <g opacity="0.35">
                    <path
                      d="M301.514 235.324L301.773 235.048L301.514 234.772L258.301 188.857V149.136L339.157 235.048L258.301 320.986V281.265L301.514 235.324ZM166.383 235.074L247.239 149.136V188.857L185.062 254.922L166.383 235.074ZM221.564 293.68L247.239 266.375V320.959L221.564 293.68ZM193.729 264.102L247.241 207.244V247.935L212.877 284.448L193.729 264.102Z"
                      stroke="#E9B460"
                      strokeWidth="0.805"
                    ></path>
                  </g>
                  <g opacity="0.07">
                    <path
                      d="M135.684 198.293L135.943 198.017L135.684 197.741L92.471 151.826V112.105L173.327 198.017L92.471 283.955V244.233L135.684 198.293ZM0.55269 198.043L81.409 112.105V151.826L19.2324 217.891L0.55269 198.043ZM55.7343 256.649L81.4086 229.344V283.928L55.7343 256.649ZM27.8988 227.071L81.4107 170.213V210.904L47.047 247.416L27.8988 227.071Z"
                      stroke="#E9B460"
                      strokeWidth="0.805"
                    ></path>
                  </g>
                  <g opacity="0.08">
                    <path
                      d="M402.139 129.062L402.398 128.786L402.139 128.51L358.926 82.5957V42.8743L439.782 128.786L358.926 214.724V175.003L402.139 129.062ZM267.008 128.812L347.864 42.8746V82.5957L285.687 148.66L267.008 128.812ZM322.189 187.418L347.864 160.113V214.698L322.189 187.418ZM294.354 157.84L347.866 100.983V141.674L313.502 178.186L294.354 157.84Z"
                      stroke="#E9B460"
                      strokeWidth="0.805"
                    ></path>
                  </g>
                  <g opacity="0.1">
                    <path
                      d="M239.529 87.2027L239.788 86.9268L239.528 86.651L196.316 40.7364V1.01496L277.172 86.9269L196.316 172.865V133.144L239.529 87.2027ZM104.397 86.953L185.254 1.01518V40.7364L123.077 106.801L104.397 86.953ZM159.579 145.559L185.253 118.254V172.838L159.579 145.559ZM131.744 115.981L185.255 59.1234V99.8141L150.892 136.326L131.744 115.981Z"
                      stroke="#E9B460"
                      strokeWidth="0.805"
                    ></path>
                  </g>
                </svg>
              </div>
            </div>
            <div>
              <div className="mb-2 grid justify-center">
                <span className="flex w-fit justify-center rounded-[5px] border-solid border-border-secondary p-3 text-content-active">
                  <img src="/images/xlsx2.svg" className="w-16 h-16 text-green-600" alt="" />
                </span>
              </div>
              <h3 className="m-0 mb-2 text-headings-h4 text-content-primary">
                {t('UploadTradeHistory')}
              </h3>
              <div className="mx-8 mb-2 text-headings-headline text-functional-active">
                {t('UploadTradeHistoryDesc')}
              </div>
            </div>
            <ul className="mb-0 list-none p-6">
              <li className="align-center mb-4 flex items-center gap-3 text-left text-buttons-large text-content-secondary last:mb-0">
                <div
                  aria-hidden="true"
                  className="_svgXs_12opb_18 p-[6px] rounded-[4px] bg-symbol-badge-primary-opacity text-symbol-badge-primary-full h-fit w-fit leading-[0px]"
                  data-sentry-component="FunctionalIcon"
                  data-sentry-source-file="FunctionalIcon.tsx"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.7209 3L8.60465 14.8446L4.30232 10.2604L1 13.7791L8.60465 21.8571L23 6.51868L19.7209 3Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                {t('uploadMessage1')}
              </li>
              <li className="align-center mb-4 flex items-center gap-3 text-left text-buttons-large text-content-secondary last:mb-0">
                <div
                  aria-hidden="true"
                  className="_svgXs_12opb_18 p-[6px] rounded-[4px] bg-symbol-badge-primary-opacity text-symbol-badge-primary-full h-fit w-fit leading-[0px]"
                  data-sentry-component="FunctionalIcon"
                  data-sentry-source-file="FunctionalIcon.tsx"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.7209 3L8.60465 14.8446L4.30232 10.2604L1 13.7791L8.60465 21.8571L23 6.51868L19.7209 3Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                {t('uploadMessage2')}
              </li>
              <li className="align-center mb-4 flex items-center gap-3 text-left text-buttons-large text-content-secondary last:mb-0">
                <div
                  aria-hidden="true"
                  className="_svgXs_12opb_18 p-[6px] rounded-[4px] bg-symbol-badge-primary-opacity text-symbol-badge-primary-full h-fit w-fit leading-[0px]"
                  data-sentry-component="FunctionalIcon"
                  data-sentry-source-file="FunctionalIcon.tsx"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.7209 3L8.60465 14.8446L4.30232 10.2604L1 13.7791L8.60465 21.8571L23 6.51868L19.7209 3Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                {t('uploadMessage3')}
              </li>
              <li className="align-center mb-4 flex items-center gap-3 text-left text-buttons-large text-content-secondary last:mb-0">
                <div
                  aria-hidden="true"
                  className="_svgXs_12opb_18 p-[6px] rounded-[4px] bg-symbol-badge-primary-opacity text-symbol-badge-primary-full h-fit w-fit leading-[0px]"
                  data-sentry-component="FunctionalIcon"
                  data-sentry-source-file="FunctionalIcon.tsx"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-message-circle-warning-icon lucide-message-circle-warning text-red-400">
                    <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" /><path d="M12 8v4" /><path d="M12 16h.01" />
                  </svg>

                </div>
                {t('uploadMessage4')}
              </li>
            </ul>
            <div className="flex gap-2">
              <Button className="px-2 py-2 no-underline sm:text-[10px] md:text-[12px] text-[14px] rounded-md relative z-0 mt-3 bg-white text-black outline outline-2 outline-gray-400 outline-offset-0 _fullWidth_rcmwj_278" onClick={showUpload}>
                {t('uploadFile')} Excel
              </Button>
            </div>
            <Modal
              title="Upload file Excel"
              open={showUploadExcel}
              onCancel={cancelShowUpload}
              footer={[
                <Button className="checkbox-upload-btn" onClick={tradeHistoryImport} style={{ cursor: isImport ? 'not-allowed' : 'pointer', pointerEvents: isImport ? 'none' : 'all', opacity: isImport ? '0.3' : '1' }}>{t('Upload')}</Button>,
                <Button key="close" onClick={cancelShowUpload}>
                  {t("Close")}
                </Button>,
              ]}
            >
              <p className="text-sm  mb-1">
                {t('SelecttheExcelfile')}
              </p>
              <Dragger {...props}
                maxCount={1}
                accept=".xlsx, .xls, .csv"
                beforeUpload={(file) => {
                  setFile(file);
                  return false; // Prevent automatic upload
                }}
                customRequest={({ file, onSuccess }) => {
                  // Handle the file upload here
                  console.log('File ready for upload:', file);
                  // Simulate a successful upload
                  setTimeout(() => {

                    message.success(`${file.toString()} file uploaded successfully.`);
                  }, 1000);
                }}
                data-testid="upload-dragger">
                <p className="ant-upload-drag-icon">
                  <CloudUploadOutlined />
                </p>
                <p className="ant-upload-text font-normal">{t('uploadText')}</p>
              </Dragger>
              <p className="mb-3 text-gray-600 mt-3">
                {t('uploadText2')}
              </p>
              {options && <div className="wrap-checkbox-upload flex flex-col gap-2">
                <Radio.Group
                  options={options}
                  onChange={handleChange}
                  value={checkedList}
                  className="flex flex-col gap-2 [&_.ant-radio-wrapper]:!block"
                />
              </div>}
            </Modal>
          </div>
        </div>
      </div>

      <div className="footer mb-5 mb-md-auto">
        <div className="row my-4 small">
          <div className="col-12 small text-center text-md-end mb-md-1 mb-2 fw-bold">
            <a href="#" id="ftmo-cookie-settings" className="">
              {" "}
              {t('CookieSettings')}{" "}
            </a>
            &nbsp;
            <a
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#modal_privacy_policy"
            >
              {" "}
              {t('PrivacyPolicy')}
              {" "}
            </a>
            &nbsp;
            <a href="#" id="footer__link-terms-conditions">
              {" "}
              {t('TermsConditions')}
              {" "}
            </a>
          </div>

          <div className="col-12 small">
            <p>
              {t('disclaimerFull')}
            </p>
          </div>
          {/* <div className="col-12 small text-left">
            2025 © Copyright - LUMIR.com Made with{" "}
            <span className="text-danger">❤</span> for trading.
          </div>
          <div className="col-12">
            <small>Version: 375a29ca </small>
          </div> */}
        </div>
      </div>
    </>
  );
};
